<template>
  <div class="container products-wrap px-2 py-2 border">
      <div class="title-wrap border-bottom mb-3">
        <h1>{{$ml.with('VueJS').get('PharmCompanyProducts')}}</h1>
      </div>

      <div class="list-wrap" v-if="productsList.length > 0">
          <div class="pagination-wrap" v-if="pageCount > 1">
              <b-pagination
                      v-model="currentPage"
                      :total-rows="totalCount"
                      :per-page="perPage"
                      :disabled="isLoading"
                      size="sm"
              ></b-pagination>
          </div>

          <b-table
                  striped
                  hover
                  small
                  id="products-list"
                  :items="productsList"
                  :fields="fields"
          >
              <template v-slot:cell(actions)="row">
                  <b-button @click="showProductEditModal(row)" size="sm">
                      <font-awesome-icon icon="edit"></font-awesome-icon>
                  </b-button>
              </template>
          </b-table>

          <div class="pagination-wrap" v-if="pageCount > 1">
              <b-pagination
                      v-model="currentPage"
                      :total-rows="totalCount"
                      :per-page="perPage"
                      :disabled="isLoading"
                      size="sm"
              ></b-pagination>
          </div>

          <div class="text-right">{{$ml.with('VueJS').get('Page')}}: {{ currentPage }} / {{ pageCount }}</div>
      </div>

      <b-modal id="productParams" hide-footer title="Параметры" v-model="showProductParams">
          <div class="params-wrap">
              <b-form-group
                      id="input-group-ru_name"
                      :label="$ml.with('VueJS').get('ProductRuName')"
                      label-for="input-ru_name"
                      description=""
              >
                  <b-form-input
                          id="input-ru_name"
                          v-model="currentProduct.ru_name"
                          type="text"
                          required
                          placeholder=""
                  ></b-form-input>
              </b-form-group>

              <b-form-group
                      id="input-group-en_name"
                      :label="$ml.with('VueJS').get('ProductEnName')"
                      label-for="input-en_name"
                      description=""
              >
                  <b-form-input
                          id="input-en_name"
                          v-model="currentProduct.en_name"
                          type="text"
                          required
                          placeholder=""
                  ></b-form-input>
              </b-form-group>

              <b-form-group
                      id="input-group-ru_producer"
                      :label="$ml.with('VueJS').get('ProductProducerRuName')"
                      label-for="input-ru_producer"
                      description=""
              >
                  <b-form-input
                          id="input-ru_producer"
                          v-model="currentProduct.ru_producer"
                          type="text"
                          required
                          placeholder=""
                  ></b-form-input>
              </b-form-group>

              <b-form-group
                      id="input-group-en_producer"
                      :label="$ml.with('VueJS').get('ProductProducerEnName')"
                      label-for="input-en_producer"
                      description=""
              >
                  <b-form-input
                          id="input-en_producer"
                          v-model="currentProduct.en_producer"
                          type="text"
                          required
                          placeholder=""
                  ></b-form-input>
              </b-form-group>

              <b-form-checkbox v-model="currentProduct.active" class="mb-2 mr-sm-2 mb-sm-0">{{$ml.with('VueJS').get('ProductActiveState')}}</b-form-checkbox>

              <div>
                  <b-button class="float-right" variant="danger" @click="setProductParams()">{{$ml.with('VueJS').get('Save')}}</b-button>
              </div>
          </div>
      </b-modal>
  </div>
</template>

<style>
    .b-form-file {
        overflow: hidden;
    }
</style>
<script>
  import mixinUtils from "@/components/mixinUtils";

  export default {
    name: 'pharm-company-products',
    mixins: [mixinUtils],
    components: {
    },
    data: () => ({
      form: {
        file: null,
        pharm_company_id: null,
      },
      filter: {
        pcId: null,
      },
      currentProduct: {
        id: null,
        active: null,
        code: null,
        en_name: null,
        ru_name: null,
        en_producer: null,
        ru_producer: null,
      },
      fields: [
        {
          key: 'id',
          label: '#',
          sortable: false
        },
        {
          key: 'ru_name',
          label: 'Информация о товаре',
          sortable: false
        },
        {
          key: 'maker.ru_name',
          label: 'Производитель',
          sortable: false
        },
        {
          key: 'actions',
          label: '',
        }
      ],
      showProductParams: false,
      productsList: [],
      pharmCompaniesList: [],
      isLoading: false,
      currentPage: 1,
      pageCount: 1,
      totalCount: null,
      perPage: 20,
    }),
    methods: {
      showProductEditModal(row) {
        this.currentProduct = row.item
        this.currentProduct.ru_producer = row.item.maker.ru_name
        this.currentProduct.en_producer = row.item.maker.en_producer
        this.showProductParams = true
      },
      setProductParams () {
        const contex = this
        if (contex.isLoading) return;

      },
      getProducts () {
        const contex = this
        if (contex.isLoading) return;

        contex.isLoading = true
        const pharmCompanyId = contex.filter.pcId ? contex.filter.pcId : ''
        contex.apiCall(`products/index?expand=pc,maker,cat,catFtg,catPhgr&pc_id=${pharmCompanyId}&page=${contex.currentPage}&per-page=${contex.perPage}`, 'post', {})
          .then(function (response) {
            if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно получены`, {
                title: 'Список продуктов ФК',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }

            contex.productsList = []
            for (let i = 0; i < response.data.items.length; i++) {
              const data = response.data.items[i]

              contex.productsList.push(data)
            }

            contex.currentPage = response.data._meta.currentPage
            contex.pageCount = response.data._meta.pageCount
            contex.totalCount = response.data._meta.totalCount

            contex.isLoading = false
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {
          contex.isLoading = false
        })
      },
      getPharmcompanies () {
        const contex = this

        contex.apiCall(`pharmcompany/index?page=1&per-page=10000`, 'post', {})
          .then(function (response) {
            if (response.data.status === 200) {
              contex.$bvToast.toast(`Данные успешно получены`, {
                title: 'Список фарм компаний',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: false,
                toaster: 'b-toaster-bottom-right',
              })
            }

            contex.pharmCompaniesList = []
            for (let i = 0; i < response.data.items.length; i++) {
              const data = response.data.items[i]
              contex.pharmCompaniesList.push(data)
            }
          })
          .catch(function (error) {
            console.error(error)
          }).finally(function () {

        })
      }
    },
    mounted() {
      const context = this
      context.getPharmcompanies()
      context.getProducts()
    },
    watch: {
      currentPage: {
        // eslint-disable-next-line no-unused-vars
        handler: function(newVal, oldVal) {
          this.getProducts()
        }
      }
    },
    computed: {
      availablePharmCompanies () {
        const options = []
        for (let i = 0; i < this.pharmCompaniesList.length; i++) {
          const item = this.pharmCompaniesList[i]
          options.push({
            value: item.id,
            text: item.name,
          })
        }
        return options
      },
    }
  }
</script>